import { computed } from 'vue'

import { notifications } from '@/shared/composables/calls-notifications'

export const useActivePickupNotifications = () => {
  const pickupNotifications = computed(() => Array.from(notifications.value.values()))
  const pickupCount = computed(() => notifications.value.size)

  return {
    pickupNotifications,
    pickupCount,
  }
}
